import Vue from 'vue'
import Router from 'vue-router'
import MobileDetect from 'mobile-detect'

//PC
import Product from '../views/components/Product'
import Company from '../views/components/Company'
import JoinUs from '../views/components/JoinUs'
import ContactUs from '../views/components/ContactUs'

//Mobile
import mCompany from '../views/components/Mobile/MCompany'
import mProduct from '../views/components/Mobile/MProduct'
import mJoinUs from '../views/components/Mobile/MJoinUs'
import mContactUs from '../views/components/Mobile/MContactUs'

Vue.use(Router)
let md = new MobileDetect(window.navigator.userAgent)
let routes = []
if (md.phone()) {
  routes = [{
      path: '/',
      redirect: '/company'
    },
    {
      path: '/product',
      name: 'MPRODUCT',
      component: mProduct
    },
    {
      path: '/company',
      name: 'MCOMPANY',
      component: mCompany
    },
    {
      path: '/joinus',
      name: 'MJOINUS',
      component: mJoinUs
    },
    {
      path: '/contactus',
      name: 'MCONTACTUS',
      component: mContactUs
    },
  ]
} else {
  routes = [{
      path: '/',
      redirect: '/company'
    },
    {
      path: '/product',
      name: 'PRODUCT',
      component: Product
    },
    {
      path: '/company',
      name: 'COMPANY',
      component: Company
    },
    {
      path: '/joinus',
      name: 'JOINUS',
      component: JoinUs
    },
    {
      path: '/contactus',
      name: 'CONTACTUS',
      component: ContactUs
    },
  ]
}

const createRouter = () => new Router({
  mode: 'history', // require service support
  // scrollBehavior: () => ({ y: 0 }),
  routes
})

const router = createRouter()
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router